import Modal from 'react-responsive-modal';
import QRCode from 'qrcode.react';
import { Button } from '../../../../components/Button';
import { useEffect, useState } from 'react';
import { useAuth } from '../../../../hooks/useAuth';
import { useEvents } from '../../../../hooks/useEvents';
import { IGenerateQrCodeResponse } from '../../../../interfaces/IEvent';

export function QrCodeModal({ open, onClose, eventId }) {
  const { player } = useAuth();
  const { generateQrCode } = useEvents();
  const [qrCode, setQrCode] = useState<IGenerateQrCodeResponse>();

  useEffect(() => {
    const fetchQrCode = async () => {
      const response = await generateQrCode({
        eventId,
        playerId: player.id,
        email: player.email,
        name: player.name,
        cpf: player.cpf,
      });
      setQrCode(response);
    };
    if (open) {
      fetchQrCode();
    }
  }, [player, eventId, open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      styles={{
        modal: {
          maxWidth: '400px',
          width: '90%',
          borderRadius: '12px',
          padding: '0',
        },
      }}
    >
      <div style={{ margin: '1rem' }}>
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              marginBottom: '1rem',
            }}
          >
            <span>Qr Code de Registro</span>
          </div>
          <div style={{ marginBottom: '1rem', fontSize: '1rem' }}>
            <span>Escaneie esse QRCode para registrar sua presença</span>
          </div>
          {qrCode?.qrCodeId && (
            <div style={{ marginBottom: '1rem', fontSize: '1rem' }}>
              <QRCode value={qrCode?.qrCodeId} size={250} />
            </div>
          )}
        </div>
        <div
          style={{
            textAlign: 'center',
            marginTop: '1rem',
          }}
        >
          <span>Válido por 24 horas</span>
        </div>
      </div>
      <Button
        isModal
        text={'Fechar'}
        type="submit"
        color="primary"
        onClick={onClose}
      />
    </Modal>
  );
}
